/**
 * Copyright © Veeam Software Group GmbH.
 */

import { OverviewTrend as OverviewTrendModel } from '@veeam-vspc/models/web-controllers';

export type OverviewTrend = OverviewTrendModel;
export const OverviewTrend = OverviewTrendModel;
